import React from "react";
import { useTranslation } from "react-i18next";
import { DirectImageUploadButton } from "../../Media/DirectImageUploadButton";

/**
 * Checklist item wrapper for direct image upload.
 * Pass previewOptions.drawingSupport + project (and optional linkedDrawing)
 * to enable Tegninger markering when uploading from checklist fill.
 */
export function ChecklistItemDirectImageUpload({
  item,
  disabled = false,
  subtitle,
  className,
  previewOptions,
  onDocumentsChange,
}) {
  const { t } = useTranslation();

  return (
    <DirectImageUploadButton
      module="checklist_item"
      moduleParam={item?.id}
      disabled={disabled || !item?.id}
      subtitle={
        subtitle ||
        t("quality.checklist.item.uploadImageDestination", { title: item?.title })
      }
      className={className}
      previewOptions={previewOptions}
      onUploadComplete={onDocumentsChange}
    />
  );
}
